import moduleTemplate from './moduleTemplate'
import carsAPI from '@/api/servecars'

const template = moduleTemplate(carsAPI)

template.types = {
  ...template.types,
  setSearchText: 'setSearchText'
}
template.mutations = {
  ...template.mutations,
  [template.types.setSearchText] (state, value) {
    state.searchText = value
  }
}
template.state = {
  ...template.state,
  searchText: '',
  expandAllItems: ['lastState', 'nextServiceRecord']
}

template.actions = {
  ...template.actions,
  setSearchText ({ commit }, searchText) {
    commit(template.types.setSearchText, searchText)
  }
}
export default template
